import React from 'react';
import Text from '../../../v2BaseComponents/Text';
import Stack from '../../../v2BaseComponents/Stack';
import { getSpacing } from '../../../../utils/spacing';

type ExpandableInformationSubsectionProps = {
    title: string;
    contents: string[];
};

const ExpandableInformationSubsection: React.FC<ExpandableInformationSubsectionProps> = ({ title, contents }) => {
    return (
        <Stack vertical space={getSpacing(1)}>
            <Text
                variant="subtitle-1"
                style={{
                    fontFamily: 'OverpassBold',
                }}
            >
                {title}
            </Text>
            <Stack space={getSpacing(4)} vertical>
                {contents.map((content, index) => (
                    <Text
                        key={index}
                        variant="h5"
                        color="Gray-Text"
                        style={{
                            lineHeight: 26,
                        }}
                    >
                        {content}
                    </Text>
                ))}
            </Stack>
        </Stack>
    );
};

export default React.memo(ExpandableInformationSubsection);
